// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"v1-z"};